import React from 'react'
import { DonutCharts, SubjectBreakdowns } from './StudentReport'

export default function StudentReportPage({studentScore, subtests, nodes, destructuredSubtests, headerText}) {
  return (
    <div className="new-page vertical-content student-report">
      <section className="page-header">
        <h3 className="page-title">{`${studentScore.fullName} Score Report`}</h3>
        <h3 className="school-class-info">{headerText}</h3>
      </section>
      <DonutCharts 
        studentScore={studentScore}
        subtests={subtests}
      />
      <SubjectBreakdowns
        studentScore={studentScore}
        subtests={subtests}
        nodes={nodes}
        destructuredSubtests={destructuredSubtests}
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReportPage.js